import { ClassifyCurdVm } from "../../models/view/classify-curd.vm";

export class ClassifyCurdEvents {
    constructor(public  classify: ClassifyCurdVm) {
    }
}
